var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[(
      _vm.$route.name !== 'UserProblemDetail' &&
        _vm.$route.name !== 'DetailUserAnswer'
    )?_c('AppSideBar',{staticClass:"main-side-bar",attrs:{"toggleCollapsed":_vm.toggleCollapsed}}):_vm._e(),_c('div',{staticClass:"main",style:(_vm.toggleCollapsed ? '' : 'width: calc(100% - 197px);')},[_c('AppHeader',{attrs:{"toggleCollapsed":_vm.toggleCollapsed},on:{"toggle-collapsed":_vm.handleToggleCollapsed}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }